import React from 'react';
import AboutComponent from '../components/About';

const About: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-gray-50 to-white">
      <div className="pt-24 pb-16 px-4">
        <AboutComponent />
      </div>
    </div>
  );
};

export default About;
